import axios from "axios";
import { authService } from "./auth/auth.service";
import { ERROR_MSGS } from '../helpers/error/errorMessages';
import { errorHandleParser } from '../helpers/error/errorHandler'; 
import "@/assets/css/styles.css";

const API_VERSION_HEADER = "api-version";

export const apiService = {
  getUser,
  authUser,
  getUserProfile,
  getUserCreditInfo,
  refreshUserToken,
  createPinCode,
  mobileVerification,
  resendMobileVerificationCode,
  customerUpdate,
  getCustomerId,
  registerUser,
  UserPaymentDetails,
  createPaymentSession,
  checkThreeDS,
  payerAuthentication,
  getCustomerProvince,
  getCustomerDistrict,
  getCustomerCity,
  sendPasswordResetRequest,
  getCustomerOrderTransactionsByStatus,
  getCustomerOrderDetail,
  attemptPay,
  getStatus,
  changeAddedPaymentMethod,
  submitDefaultPaymentMethod
};

function getUser(mobileNo) {
  return new Promise((res, rej) => {
    axios
      .get(
        process.env.VUE_APP_BACKEND_URL +
        "customers/profile/name?mobileNo=" +
        mobileNo
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        const code =
          err.validationFailures && err.validationFailures[0]
            ? err.validationFailures[0].code
            : "";
        if (code == "customer.viewByMobile.customer.notExists") {
          err.message = ERROR_MSGS.NONEXISTING_ACC;
        }
        rej(err);
      });
  });
}

function getStatus(statusRequest) {
  return new Promise((res, rej) => {
    axios
      .get(
        process.env.VUE_APP_BACKEND_URL + "daraz/customers/whitelist/status?darazUserId=" + statusRequest.darazUserId + "&mobileNo=" + statusRequest.mobileNo
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
      });
  });
}

function authUser(loginRequest) {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "mobile-users/auth", loginRequest)
      .then((response) => {
        const resp = response.data.content;
        authService.startRefreshTokenTimer(resp.expires_in);
        res(resp);
      })
      .catch((err) => {
        const code =
          err.validationFailures && err.validationFailures[0]
            ? err.validationFailures[0].code
            : "";
        if (code == "invalid_grant.BadCredentials") {
          err.message = ERROR_MSGS.INCORRECT_PASSWORD;
        } else if (code == "invalid_grant.UserAccountLocked") {
          err.message = ERROR_MSGS.ACC_LOCK;
        }
        rej(err);
      });
  });
}

function getUserProfile() {
  return new Promise((res, rej) => {
    axios
      .get(process.env.VUE_APP_BACKEND_URL + "customers/current-profile")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getUserCreditInfo(customerId) {
  return new Promise((res, rej) => {
    axios
      .get(
        process.env.VUE_APP_BACKEND_URL +
        "customers/" +
        customerId +
        "/credit-info"
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function refreshUserToken() {
  const refresh_token = localStorage.getItem("refreshToken");
  if (refresh_token) {
    const loginRequest = {
      grant_type: "refresh_token",
      refresh_token: refresh_token,
    };
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "mobile-users/auth", loginRequest)
      .then((response) => {
        const resp = response.data.content;
        authService.startRefreshTokenTimer(resp.expires_in);
        authService.setUserTokens(resp.access_token, resp.refresh_token);
      });
  }
}

function getCustomerId() {
  return JSON.parse(localStorage.getItem("customer"))["id"];
}

function createPinCode(formData) {
  return new Promise((res, rej) => {
    axios
      .put(process.env.VUE_APP_BACKEND_URL + "daraz/customers/info", formData)
      .then((response) => {
        res(response.data.content);
        sessionStorage.removeItem("pinNo");
      })
      .catch((err) => {
        rej(err);
      });
  });
}
function UserPaymentDetails(customer_id) {
  return new Promise((res, rej) => {
    axios
      .get(process.env.VUE_APP_BACKEND_URL + "payment/customers/" + customer_id + "/payment-methods")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function createPaymentSession() {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "session")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function checkThreeDS(formData, sessionId) {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + 'session/' + sessionId + '/3ds', formData)
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        const code = err.validationFailures[0].code;
        console.log("error messege", code)

        if (code == "tokenize.session.paymentMethod.exists") {
          err.message = ERROR_MSGS.EXISTING_PAYMENT_METHOD;
        } else {
          err.message = ERROR_MSGS.INVALID_PAYMENT_MEHTOD;
        }
        rej(err);
      });
  });
}

function payerAuthentication(formData, sessionId) {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + 'session/' + sessionId + '/payer-authentication', formData)
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);

      });
  });
}

function mobileVerification(otp) {
  return new Promise((res, rej) => {
    axios
      .get(
        process.env.VUE_APP_BACKEND_URL +
        "daraz/customers/" +
        this.getCustomerId() +
        "?otp=" +
        otp
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        const code =
          err.validationFailures && err.validationFailures[0]
            ? err.validationFailures[0].code
            : "";
        if (code == "customerMobileNumberVerificationRequest.otp.invalid") {
          err.message = ERROR_MSGS.INVALID_OTP;
        } else if (
          code == "customerMobileNumberVerificationRequest.otp.expired"
        ) {
          err.message = ERROR_MSGS.EXPIRED_OTP;
        }
        rej(err);
      });
  });
}

function resendMobileVerificationCode(formData) {
  return new Promise((res, rej) => {
    axios
      .put(
        process.env.VUE_APP_BACKEND_URL +
        "mobile/customers/" +
        this.getCustomerId() +
        "/resend-otp",
        formData
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function customerUpdate(formData) {
  return new Promise((res, rej) => {
    axios
      .put(
        process.env.VUE_APP_BACKEND_URL +
        "daraz/customers/" +
        this.getCustomerId(),
        formData,
        {
          headers:
            { [API_VERSION_HEADER]: '2.0' }
        })
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        const errors = err?.validationFailures;
        if (
          errors[0].code == "customerInfo.update.customer.emailAlreadyExists"
        ) {
          err.message = ERROR_MSGS.EXISTING_EMAIL;
          rej(err);
          return;
        }
        if (errors[0].code == "customerInfo.update.customer.nicAlreadyExists") {
          err.message = ERROR_MSGS.EXISTING_NIC;
          rej(err);
          return;
        }
        if (errors[0].code == "customer.update.nic.invalid") {
          err.message = ERROR_MSGS.INVALID_NIC;
          rej(err);
          return;
        }
        err.message = errors[0].code;
        rej(err);
      });
  });
}

function registerUser(regRequest) {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "daraz/customers", regRequest)
      .then((response) => {
        const resp = response.data.content;
        res(resp);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getCustomerProvince() {
  return new Promise((res, rej) => {
    axios
      .get(process.env.VUE_APP_BACKEND_URL + "provinces")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getCustomerDistrict(provinceId) {
  return new Promise((res, rej) => {
    axios
      .get(process.env.VUE_APP_BACKEND_URL + "provinces/" + provinceId + "/districts")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getCustomerCity(provinceId, districtId) {
  return new Promise((res, rej) => {
    axios
      .get(process.env.VUE_APP_BACKEND_URL + "provinces/" + provinceId + "/districts/" + districtId + "/cities")
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function sendPasswordResetRequest(passwordResetRequest) {
  return new Promise((res, rej) => {
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "customers/password-reset", passwordResetRequest)
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getCustomerOrderTransactionsByStatus(status, page, size, cancelToken = null) {

  return new Promise((res, rej) => {
    axios
      .get(
        `${process.env.VUE_APP_BACKEND_URL}payment/customers/${getCustomerId()}/orders/transactions?page=${page}&size=${size}&status=${status}`,
        {
          headers:
            { [API_VERSION_HEADER]: '2.0' },
          cancelToken: cancelToken
        }
      )
      .then((response) => {
        const urlParams = new URLSearchParams(response.request.responseURL);
        const status = urlParams.get('status');
        res({ data: response.data.content, type: status });
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function getCustomerOrderDetail(orderId) {
  return new Promise((res, rej) => {
    axios
      .get(
        `${process.env.VUE_APP_BACKEND_URL}payment/customers/${getCustomerId()}/orders/${orderId}`
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

function attemptPay(payRequest) {
  return new Promise((res, rej) => {
    axios
      .put(
        `${process.env.VUE_APP_BACKEND_URL}payment/customers/${getCustomerId()}/orders/${payRequest.orderId}/pay`, payRequest
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        err.message = errorHandleParser.captureErrorMessage(err);
        rej(err);
      });
  });
}


function changeAddedPaymentMethod(payRequest) {
  return new Promise((res, rej) => {
    axios
      .put(
        `${process.env.VUE_APP_BACKEND_URL}payment/customers/${getCustomerId()}/orders/${payRequest.orderId}/transactions/${payRequest.transactionId}/payment-method`, payRequest
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        err.message = errorHandleParser.captureErrorMessage(err);
        rej(err);
      });
  });
}
      
function submitDefaultPaymentMethod(paymentMethodId) {
  return new Promise((res, rej) => {
    axios
      .put(
        `${process.env.VUE_APP_BACKEND_URL}payment/customers/${getCustomerId()}/payment-methods/${paymentMethodId}/submit-default-method`, {}
      )
      .then((response) => {
        res(response.data.content);
      })
      .catch((err) => {
        err.message = errorHandleParser.captureErrorMessage(err);
        rej(err);
      });
  });
}
